<mat-card class="mb-25 tagus-card">
  <mat-card-header class="border-bottom">
    <h5 class="mb-0">{{ data.name }}</h5>
    <button mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </mat-card-header>
  <mat-card-content>
    <div *ngIf="isLoading">Aguarde... Buscando informações!</div>
    <div class="timeline" *ngIf="!isLoading">
      <div class="event" *ngFor="let history of histories">
        <div class="inner">
          <span class="date fw-semibold"></span>
          <h5 class="mb-12">{{ statusToBr(history.action) }}</h5>
          <span class="d-block muted-color mb-12 fs-14">{{
            history.createdAt | date : "short"
          }}</span>
          <p>
            {{ history.reason }}
          </p>
        </div>
      </div>
    </div>
  </mat-card-content>
</mat-card>
